var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Remixicon',{class:{ met: _vm.isMet },attrs:{"name":_vm.isMet ? 'ri-checkbox-circle-line' : 'ri-close-circle-line'}})
}
var staticRenderFns = []

export { render, staticRenderFns }